import {
	ConfigurePasswordDto,
	restRepository,
	SignupDto,
	SignUpResponseDto,
	UpdatePhoneDto,
} from "@onair/repositories";

export const signUp = async (
	request: SignupDto,
): Promise<SignUpResponseDto> => {
	const { data } = await restRepository.api.authSignup(request);
	return data as SignUpResponseDto;
};

export const updatePhone = async (request: UpdatePhoneDto) => {
	const { data } = await restRepository.api.authControllerUpdatePhone(request);
	return data;
};

export const configurePassword = async (input: ConfigurePasswordDto) => {
	const { data } = await restRepository.api.configurePassword(input);
	return data;
};
